import React from 'react';
import { CopyButton } from '@components/common/CopyButton';
import { Button, List, PriceString, Table, useMediaQueryContext } from '@fourthwall/components';
import { useCopyToClipboard } from '@fourthwall/components/src/hooks/useCopyToClipboard';
import { downloadCsvFile } from '@fourthwall/utils/dist/downloadCsvFile';
import * as S from './GiftCardCodesData.styled';
export const GiftCardCodesData = ({ giftCards }) => {
    const media = useMediaQueryContext();
    const { copyToClipboard } = useCopyToClipboard({
        toastMessage: 'Gift card codes copied to clipboard',
    });
    const handleCopyCodes = () => {
        const codes = giftCards?.map((giftCard) => giftCard.code).join('\n');
        if (codes) {
            copyToClipboard(codes);
        }
    };
    const handleDownloadCSV = () => {
        const codes = giftCards?.map((giftCard) => ({ code: giftCard.code }));
        if (codes) {
            downloadCsvFile(codes, 'gift_card_codes', ['code']);
        }
    };
    const TABLE_HEADERS = [
        {
            id: 'code',
            label: 'Gift card code',
            render: (giftCard) => giftCard.code,
            width: 6,
        },
        {
            id: 'Used',
            label: 'Used',
            render: (giftCard) => React.createElement(PriceString, { ...giftCard.balance.used }),
            width: 1.5,
        },
        {
            id: 'remaining',
            label: 'Remaining',
            render: (giftCard) => React.createElement(PriceString, { ...giftCard.balance.remaining }),
            width: 1.5,
        },
        {
            id: 'copy',
            label: ' ',
            render: (giftCard) => React.createElement(CopyButton, { copyText: giftCard.code, iconSize: 16 }),
            width: 0.5,
            alignment: 'right',
        },
    ];
    if (!giftCards)
        return null;
    const renderData = () => {
        if (!media.tablet) {
            return (React.createElement(List, { data: giftCards, renderItem: (giftCard) => (React.createElement("div", null,
                    React.createElement(S.GiftCardCodeWrapper, null,
                        giftCard.code,
                        " ",
                        React.createElement(CopyButton, { copyText: giftCard.code, iconSize: 16 })),
                    React.createElement(S.GiftCardBalanceWrapper, null,
                        React.createElement(PriceString, { ...giftCard.balance.used }),
                        " used /",
                        ' ',
                        React.createElement(PriceString, { ...giftCard.balance.remaining }),
                        " remaining"))) }));
        }
        return React.createElement(Table, { data: giftCards, headers: TABLE_HEADERS, minWidth: 0, compact: true });
    };
    return (React.createElement(S.Container, null,
        React.createElement(S.DataWrapper, null, renderData()),
        React.createElement(S.Footer, null,
            React.createElement(Button, { appearance: "secondary", label: "Copy to clipboard", size: "small", onClick: handleCopyCodes }),
            React.createElement(Button, { appearance: "secondary", label: "Download CSV", size: "small", onClick: handleDownloadCSV }))));
};
